import { Search, SlidersHorizontal } from 'lucide-react';
import { Input } from '@/shared/components/ui/Input';
import { Select } from '@/shared/components/ui/Select';
import { DEPARTMENT_OPTIONS } from '../constants';

interface ProjectsFilterBarProps {
  search: string;
  dept: string;
  /** Department filter is shown only for privileged users (admin/superadmin). */
  showDeptFilter: boolean;
  onSearchChange: (v: string) => void;
  onDeptChange: (v: string) => void;
}

export function ProjectsFilterBar({
  search,
  dept,
  showDeptFilter,
  onSearchChange,
  onDeptChange,
}: ProjectsFilterBarProps) {
  const deptOptions = [{ value: '', label: 'All Departments' }, ...DEPARTMENT_OPTIONS];

  return (
    <div className="flex flex-wrap items-center gap-3 rounded-card border border-outline bg-surface p-3">
      <SlidersHorizontal className="h-4 w-4 shrink-0 text-on-surface-variant" />

      {/* Client-side search: name / description / client */}
      <div className="min-w-[220px] flex-1">
        <Input
          name="project-search"
          placeholder="Search projects…"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          leftIcon={<Search className="h-4 w-4" />}
        />
      </div>

      {showDeptFilter && (
        <div className="w-48">
          <Select
            name="project-dept-filter"
            options={deptOptions}
            value={dept}
            onChange={(e) => onDeptChange(e.target.value)}
          />
        </div>
      )}
    </div>
  );
}
